import { LOADING } from '../utils/constants';

export const LoadingPanel = (
  <div className="k-loading-mask">
    <span className="k-loading-text">{LOADING}</span>
    <div className="k-loading-image"></div>
    <div className="k-loading-color"></div>
  </div>
);
